import axios from "axios";
import * as urls from "../utils/urlConst";
import { exceptionLog, getBrowserDetails, setChechSum, setLocalBankData } from "../utils/common";
import { makeRequest } from "../utils/makeRequest";
import toastNotify from "../utils/toastNotify";
const packageJson = require("./../../../package.json");

const currentVersion = packageJson.version;

export const getBankDetails = async () => {
    const getLoction: any = localStorage.getItem('location');
    const location = JSON.parse(getLoction);
    const getIdentifyData: any = localStorage.getItem('_identityData');
    const identifyData = JSON.parse(getIdentifyData);
    const browserDtl = getBrowserDetails();

    try {
        // dispatch(handleLoader(true));
        const payload = {
            Domain: window.location.hostname,
            IpAddress: identifyData.ip,
            Imei: "N/A",
            Version: currentVersion,
            Device: "Web",
            Channel: "Web",
            DeviceIpv6: "N/A",
            DeviceId: "N/A",
            DeviceMac: 'N/A',
            DeviceName: browserDtl.os.name,
            DeviceUserName: 'N/A',
            Latitude: location?.latitude.toString() || "",
            Longitude: location?.longitude.toString() || "",
            Browser: browserDtl.browser.name
        }
        const checksum = setChechSum(JSON.stringify(payload));
        const result = await axios({
            method: "POST",
            url: urls.bankDtl,
            data: payload,
            headers: {
                "Content-Type": "application/json",
                "checksum": checksum,
                'Authorization': 'Basic ' + btoa(process.env.REACT_APP_AUTHENTICATION_USERNAME + ':' + process.env.REACT_APP_AUTHENTICATION_PASSWORD),
            },
        })

        if (result.data.STATUS === "0") {
            const response = result.data.RESPONSE[0];

            const baseColor = response.Detail.filter((items: any) => items.Label === "Base color")[0].Value;

            const loginLogo = response.Detail.filter((items: any) => items.Label === "Login Logo");
            const loginLogoWidth = response.Detail.filter((items: any) => items.Label === "Login Logo Width");
            const loginLogoHeight = response.Detail.filter((items: any) => items.Label === "Login Logo Height");
            const mainLogo = response.Detail.filter((items: any) => items.Label === "Main Logo");
            const mainLogoWidth = response.Detail.filter((items: any) => items.Label === "Main Logo Width");
            const mainLogoheight = response.Detail.filter((items: any) => items.Label === "Main Logo Height");
            const Favicon = response.Detail.filter((items: any) => items.Label === "Favicon");
            const MetaKeyword = response.Detail.filter((items: any) => items.Label === "Meta Keyword");
            const MetaDescription = response.Detail.filter((items: any) => items.Label === "Meta Description");

            const logos = {
                loginLogo: loginLogo[0].Value,
                loginLogoHeight: loginLogoHeight[0].Value,
                loginLogoWidth: loginLogoWidth[0].Value,
                mainLogo: mainLogo[0].Value,
                mainLogoHeight: mainLogoheight[0].Value,
                mainLogoWidth: mainLogoWidth[0].Value,
            }

            let link: any = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.getElementsByTagName('head')[0].appendChild(link);
            }
            link.href = Favicon[0].Value;

            if (MetaKeyword.length !== 0) {
                let element = document.querySelector(`meta[name="keywords"]`);

                if (!element) {
                    element = document.createElement('meta');
                    element.setAttribute('name', "keywords");
                    element.setAttribute('content', JSON.parse(MetaKeyword[0].Value).toString());
                    document.head.appendChild(element);
                }
            }

            // if (MetaDescription.length !== 0) {
            //     let element = document.querySelector(`meta[name="description"]`);
            //     if (!element) {
            //         element = document.createElement('meta');
            //         element.setAttribute('name', "description");
            //         element.setAttribute('content', JSON.parse(MetaDescription[0].Value).toString());
            //         document.head.appendChild(element);
            //     }
            // }


            setLocalBankData(response);
            return { baseColor, logos, response }
        }
    } catch (error: any) {
        if (error.status !== 403) {
            await exceptionLog(error, "Get bank details", "N");
        }
    }
};


export const getNotificationAlerts = async () => {
    try {
        const payload = {};
        const config = {};

        const result = await makeRequest("POST", urls.getNotification, payload, config);
        if (result.STATUS === '0') {
            return result.RESPONSE;
        } else {
            result.MESSAGE !== "No Data Found" && toastNotify(result.MESSAGE, 'error');
            return result.RESPONSE;
        }
    } catch (error: any) {
        if (error.status !== 403) {
            await exceptionLog(error, "Get notification", "N");
        }
    }
};

export function checkFileMimeType(reader: any) {
    var arr = (new Uint8Array(reader.result)).subarray(0, 4);
    var header = '';
    var realMimeType;
    for (var i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
    }

    switch (header) {
        case "89504e47":
            realMimeType = "image/png";
            break;
        case "47494638":
            realMimeType = "image/gif";
            break;
        case "ffd8ffDB":
        case "ffd8ffe0":
        case "ffd8ffe1":
        case "ffd8ffe2":
        case "ffd8ffe3":
        case "ffd8ffe8":
            realMimeType = "image/jpeg";
            break;
        case "25504446":
            realMimeType = "application/pdf";
            break;
        case "504b34":
            realMimeType = "application/vnd.ms-excel";
            break;
        case "44656c69":
            realMimeType = "application/octet-stream";
            break;
        case "d0cf11e0":
            realMimeType = "application/octet-stream";
            break;
        default:
            realMimeType = "unknown"; // Or you can use the blob.type as fallback
            break;
    }
    return realMimeType;
}

export const getCaptchaCode = async () => {
    try {
        const payload = {};
        const config = {};

        const result = await makeRequest("POST", urls.getCaptchaCode, payload, config)
        if (result.STATUS === '0') {
            return result.RESPONSE[0];
        } else {
            result.MESSAGE !== "No data found" && toastNotify(result.MESSAGE, 'error');
            return null;
        }
    } catch (error: any) {
        if (error.status !== 403) {
            await exceptionLog(error, "Get captcha", "N");
        }
    }
};
